import axios, { ResponseType } from "axios";
import { getAxiosOptions } from "../headers";

const downloadFile = async (
  presignedUrl: string,
  contentType: string
): Promise<Blob> => {
  const options = {
    headers: { "Content-Type": contentType },
    responseType: "blob" as ResponseType,
    ...getAxiosOptions(),
  };

  return axios
    .get(`${presignedUrl}`, options)
    .then((response) => response.data as Blob);
};

export default downloadFile;
